@if (type() === 'link' && link().url.startsWith('#')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="className() + ' text-link'"
		(click)="setHash(link().url)"
		rel="noopener noreferrer"
		target="_self"
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'button' && link().url.startsWith('#')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="buttonClassName() + ' ' + className()"
		(click)="setHash(link().url)"
		rel="noopener noreferrer"
		target="_self"
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'link' && link().url.startsWith('http')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="className() + ' text-link'"
		[href]="link().url"
		[target]="link().target ?? '_blank'"
		(click)="linkClick.emit()"
		rel="noopener noreferrer"
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'link' && !link().url.startsWith('http')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="className() + ' text-link'"
		[fragment]="link().fragment"
		[queryParams]="link().queryParams"
		[routerLink]="routerLinkValue()"
		[routerLinkActive]="activeClass()"
		[routerLinkActiveOptions]="activeMatchOptions()"
		[target]="link().target ?? '_self'"
		(click)="linkClick.emit()"
		vc-link
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'link-unstyled' && link().url.startsWith('http')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="className()"
		[href]="link().url"
		[target]="link().target ?? '_blank'"
		(click)="linkClick.emit()"
		rel="noopener noreferrer"
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'link-unstyled' && !link().url.startsWith('http')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="className()"
		[fragment]="link().fragment"
		[queryParams]="link().queryParams"
		[routerLink]="routerLinkValue()"
		[routerLinkActive]="activeClass()"
		[routerLinkActiveOptions]="activeMatchOptions()"
		[target]="link().target ?? '_self'"
		(click)="linkClick.emit()"
		vc-link
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (
	(type() === 'button' && link().url.startsWith('http')) ||
	link().url.startsWith('mailto')
) {
	<a
		[attr.title]="link().title ?? null"
		[class]="buttonClassName() + ' ' + className()"
		[href]="link().url"
		[target]="link().target ?? '_blank'"
		(click)="linkClick.emit()"
		rel="noopener noreferrer"
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
} @else if (type() === 'button' && !link().url.startsWith('http')) {
	<a
		[attr.title]="link().title ?? null"
		[class]="buttonClassName() + ' ' + className()"
		[fragment]="link().fragment"
		[queryParams]="link().queryParams"
		[routerLink]="routerLinkValue()"
		[routerLinkActive]="activeClass()"
		[routerLinkActiveOptions]="activeMatchOptions()"
		[target]="link().target ?? '_self'"
		(click)="linkClick.emit()"
		vc-link
	>
		<ng-container *ngTemplateOutlet="linkContent" />
	</a>
}

<ng-template #linkContent>
	<ng-content />
</ng-template>
